export const EnvName = {
    Local: "local",
    Development: "development-new",
    Staging: "staging-new",
    Production: "production-new",
};
